/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCursorDrag = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M10 11H6.996V8.5L3 12l3.996 3.5L7 13h3zM13 10V6.996h2.5L12 3 8.5 6.996 11 7v3zM13.995 13H17v2.5l3.996-3.5L17 8.5l-.004 2.5h-3zM11 13.996V17H8.5l3.5 3.996L15.5 17l-2.5-.004v-3z" /></svg>;
export default SvgCursorDrag;